import { Outlet } from "react-router-dom";

import { SecondaryNavigation } from "@/components/secondary-navigation";
import { NavigationGroup } from "@/types/navigation";
import { useTranslation } from "react-i18next";

export function NotificationsLayout() {
  const { t } = useTranslation();

  const navigation: NavigationGroup[] = [
    {
      elements: [
        { name: t("nav.overview"), href: `/notifications/all` },
        { name: t("nav.statistics"), href: `/notifications/statistics` },
      ],
    },
  ];
  return (
    <div>
      <div className="grid grid-cols-12 gap-x-8">
        <div className="col-span-12 mb-4 md:block lg:col-span-3">
          <SecondaryNavigation navigations={navigation} />
        </div>
        <div className="col-span-12 lg:col-span-9">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
